import '../../resources/css/dashboard/HoodDeviceForm.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, isDirty } from 'redux-form';
import { Table, Row, Col, Button } from 'react-bootstrap';
import Geocode from "react-geocode";
import { commonRenderInput, commonRenderTableInput, commonRenderDatepicker } from '../../components/common/access-form';
import { verifyForm } from '../../components/common/access-form-validation';
import { WAIT_INIT_DEVICES, getDeviceDetail, saveDeviceDetail, forwardDashboard, SAVE_DEVICE_DETAIL_SUCCESS, SAVE_DEVICE_DETAIL_FAIL } from '../../actions/dashboard/index';
import Loading from '../../components/common/Loading';

class HoodDeviceForm extends Component {

    formSubmit = (values) => {
        const { idToken, saveDeviceDetail, isSnDirty, deviceDetail } = this.props;

        let reqBodyObj = {
            thingName: values.thingName,
            modelName: values.modelName,
            SN: values.SN,
            laborWarranty: values.laborWarranty,
            partsWarranty: values.partsWarranty,
            snDirtyFlag: isSnDirty ? 1 : 0,
            latitude: values.latitude,
            longitude: values.longitude
        };

        if (values.latitude && values.longitude && (values.latitude !== deviceDetail.latitude || values.longitude !== deviceDetail.longitude)) {
            /* -------------------- Geocode get address start --------------------*/
            reqBodyObj.changeLocationFlag = 1;

            // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
            Geocode.setApiKey(window.CONFIG.GOOGLE.apiKey);
            Geocode.setLanguage(window.CONFIG.GOOGLE.language);
            Geocode.setRegion(window.CONFIG.GOOGLE.region);
            
            // Get address from latidude & longitude.
            Geocode.fromLatLng(values.latitude, values.longitude).then(
                response => {
                    const address = this.getAddress(response.results, 0);
                    reqBodyObj.countryLong = address.country.long_name;
                    reqBodyObj.countryShort = address.country.short_name;
                    reqBodyObj.stateLong = address.state.long_name;
                    reqBodyObj.stateShort = address.state.short_name;
                    reqBodyObj.cityLong = address.city.long_name;
                    reqBodyObj.cityShort = address.city.short_name;
                    // save if latitude and longitude and transform success                    
                    saveDeviceDetail(idToken, reqBodyObj);
                },
                error => {
                    console.error(error);
                }
            );
        } else {
            reqBodyObj.changeLocationFlag = 0;
            // save if latitude and longitude and transform success
            saveDeviceDetail(idToken, reqBodyObj);
        }
    }

    getAddress = (results, count) => {
        const arrayIdx = 3 + count;
        if (results && results.length > arrayIdx) {
            const targetResult = results[results.length - arrayIdx];
            const addressArray = targetResult.address_components;
            if (addressArray.length >= 3) {
                // check data valid
                const validIdx = this.isAddressValid(addressArray)
                if (validIdx) {
                    return {
                        city: {
                            long_name: addressArray[addressArray.length - (validIdx + 2)].long_name,
                            short_name: addressArray[addressArray.length - (validIdx + 2)].short_name
                        },
                        state: {
                            long_name: addressArray[addressArray.length - (validIdx + 1)].long_name,
                            short_name: addressArray[addressArray.length - (validIdx + 1)].short_name
                        },
                        country: {
                            long_name: addressArray[addressArray.length - validIdx].long_name,
                            short_name: addressArray[addressArray.length - validIdx].short_name
                        }
                    }
                } else {
                    // response data not complete, need get next
                    return this.getAddress(results, count + 1);
                }
            } else {
                // response data not complete, need get next
                return this.getAddress(results, count + 1);
            }
        }

        return {
            city: {
                long_name: "",
                short_name: ""
            },
            state: {
                long_name: "",
                short_name: ""
            },
            country: {
                long_name: "",
                short_name: ""
            }
        }
    }

    isAddressValid = (addressArray) => {
        let validIdx = 1;
        let isValid = false
        while (validIdx + 2 <= addressArray.length) {
            const checkAddress = addressArray[addressArray.length - validIdx].short_name;
            if (isNaN(parseInt(checkAddress))) {
                isValid = true;
                break;
            } else {
                validIdx++;
            }            
        }

        return isValid ? validIdx : false;
    }

    renderOnline() {
        const { isOnline } = this.props;

        let iconClass;
        if (isOnline === 1) {
            iconClass = 'icon-online';
        } else {
            iconClass = 'icon-offline';
        }

        return (
            <div className="form-group area-online-form-group">
                <label>Status</label>
                <div className='area-online-icon'>
                    <span className={ iconClass } />
                </div>
            </div>
            
        );
    }

    componentDidMount() {
        const { status, getDeviceDetail } = this.props;

        if (status === WAIT_INIT_DEVICES) {
            // it's init devices page status, so it's refrsh page
            const deviceDetailParams = JSON.parse(window.sessionStorage.getItem('RangeHood.' + window.CONFIG.CACHE_DEVICE));
            if (deviceDetailParams) {
                getDeviceDetail(deviceDetailParams.idToken, deviceDetailParams.detailSeq);
            }
        }
    }

    componentDidUpdate (prevProps, prevState, snapshot) {        
        const { status, history, errMsg, forwardDashboard } = this.props;

        if (prevProps.status !== status) {
            // init do init
            if (status === SAVE_DEVICE_DETAIL_SUCCESS) {
                forwardDashboard();
                history.goBack();
            }

            if (status === SAVE_DEVICE_DETAIL_FAIL) {
                if (errMsg) {
                    alert(errMsg);
                }
            }
        }
    }

    selectLaborWarrantyDate = (strDate) => {
        const { change } = this.props;
        change('laborWarranty', strDate);
    }

    selectPartsWarrantyDate = (strDate) => {
        const { change } = this.props;
        change('partsWarranty', strDate);
    }

    render() {
        const { handleSubmit, readOnly, loading, verifyFormPass, match } = this.props;
        const renderOnline = this.renderOnline();

        if (loading) {
            return (
                <Loading loading={true}></Loading>
            );
        }

        // load submit button content
        let btnSubmit;
        if (match.params['formType'] === 'viewDevice'){
            // view form no display submit button
            btnSubmit = (<div className="text-align-c"></div>);
        } else {
            btnSubmit = (
                <Row>
                    <Col md={2} xl={4}>&nbsp;</Col>
                    <Col md={8} xl={4}>
                        <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>Save</Button>
                    </Col>
                    <Col md={2} xl={4}>&nbsp;</Col>
                </Row>
            );
        }
        
        return (
            <div className="hood-device-form form-custom">
                <div className='form-title'>Info</div>
                <form onSubmit={handleSubmit(this.formSubmit)}>
                    <Row>
                        <Col sm={10}><Field name="modelName" type="text" component={commonRenderInput} label="Model Number" disabled={true} /></Col>
                        <Col sm={2}>{ renderOnline }</Col>
                    </Row>
                    <Field name="thingName" type="hidden" component={commonRenderInput} disabled={true} />
                    <Field name="SN" type="text" component={commonRenderInput} label="Serial Number" disabled={readOnly} />
                    <Field name="registeredDate" type="text" component={commonRenderInput} label="Date First Registered" disabled={true} />
                    <Field name="laborWarranty" component={commonRenderDatepicker} label="Labor Warranty Expiration" callback={this.selectLaborWarrantyDate} disabled={readOnly} />
                    <Field name="partsWarranty" component={commonRenderDatepicker} label="Parts Warranty Expiration" callback={this.selectPartsWarrantyDate} disabled={readOnly} />
                    <Field name="latitude" type="text" component={commonRenderInput} label="Latitude" disabled={readOnly} />
                    <Field name="longitude" type="text" component={commonRenderInput} label="Longitude" disabled={readOnly} />                    
                    <Field name="steamclean" type="text" component={commonRenderInput} label="Steam Clean" disabled={true} />
                    <Field name="airquality" type="text" component={commonRenderInput} label="Air Quality" disabled={true} />

                    <h5>Hood Current Status</h5>
                    <Table striped className='form-list'>
                        <tbody>
                            <Field name="powerStatus" type="text" component={ commonRenderTableInput } label="Hood Status" disabled={true} />
                            <Field name="fanStatus" type="text" component={ commonRenderTableInput } label="Fan Status" disabled={true} />
                            <Field name="lightStatus" type="text" component={ commonRenderTableInput } label="Light Status" disabled={true} />
                            {/* <Field name="greaseFilter" type="text" component={ commonRenderTableInput } label="Grease Filter Remaining Time" disabled={true} />
                            <Field name="charcoalFilter" type="text" component={ commonRenderTableInput } label="Charcoal Filter Remaining Time" disabled={true} /> */}
                            <Field name="errorStatus" type="text" component={ commonRenderTableInput } label="Error Status" disabled={true} />
                            <Field name="act" type="text" component={ commonRenderTableInput } label="ACT Setting" disabled={true} />
                            <Field name="totalFanOnTime" type="text" component={ commonRenderTableInput } label="Total Fan On Time" disabled={true} />
                            <Field name="totalLightsOnTime" type="text" component={ commonRenderTableInput } label="Total Lights On Time" disabled={true} />
                        </tbody>
                    </Table>
                    { btnSubmit }
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const deviceDetail = state.dashboardReducers.deviceDetail;
    const deviceDetailInfo = state.dashboardReducers.deviceDetailInfo;
    const verifyFormPass = verifyForm(state.form['HoodDeviceForm'], ["thingName", "SN", "laborWarranty", "partsWarranty"]);
    // const location = deviceDetail.location;

    let ret = {
        idToken: state.logindReducers.idToken,
        status: state.dashboardReducers.status,
        deviceDetail: deviceDetail,
        loading: deviceDetail.loading,
        isOnline: deviceDetail.isOnline,
        isSnDirty: isDirty('HoodDeviceForm')(state, ["SN"]),
        readOnly: false,
        verifyFormPass : verifyFormPass
    };

    // set read only in viewDevice
    const { formType } = ownProps.match.params;
    if (formType === "viewDevice") {
        ret['readOnly'] = true;  
    }

    const hoodDeviceForm = state.form.HoodDeviceForm;
    if (deviceDetailInfo && !deviceDetail['loading'] && hoodDeviceForm && !hoodDeviceForm['initial']) {
        let initialValues = {};
        initialValues['modelName'] = deviceDetailInfo['modelName'];
        initialValues['SN'] = deviceDetailInfo['SN'];
        initialValues['thingName'] = deviceDetailInfo['thingName'];        
        initialValues['registeredDate'] = deviceDetailInfo['registeredDate'];
        initialValues['laborWarranty'] = deviceDetailInfo['laborWarranty'];
        initialValues['partsWarranty'] = deviceDetailInfo['partsWarranty'];
        initialValues['longitude'] = deviceDetailInfo['longitude'];
        initialValues['latitude'] = deviceDetailInfo['latitude'];
        initialValues['steamclean'] = deviceDetailInfo['steamclean'];
        initialValues['airquality'] = deviceDetailInfo['airquality'];
        initialValues['act'] = deviceDetailInfo['act'];
        initialValues['totalFanOnTime'] = deviceDetailInfo['usefantime'];
        initialValues['totalLightsOnTime'] = deviceDetailInfo['uselighttime'];
        initialValues['powerStatus'] = deviceDetailInfo['power'];
        initialValues['fanStatus'] = deviceDetailInfo['fan'];
        initialValues['lightStatus'] = deviceDetailInfo['light'];
        // initialValues['greaseFilter'] = deviceDetailInfo['remainGrease'];
        // initialValues['charcoalFilter'] = deviceDetailInfo['remainCharcoal'];
        initialValues['errorStatus'] = deviceDetailInfo['faultCode'] ? deviceDetailInfo['faultCode'].toString() : '';
        ret['initialValues'] = initialValues;
    }

    return ret;
}

HoodDeviceForm = reduxForm({
    form: 'HoodDeviceForm',  // a unique identifier for this form
})(HoodDeviceForm)
  
export default connect(
    mapStateToProps,
    { getDeviceDetail, saveDeviceDetail, forwardDashboard }
)(HoodDeviceForm);